(() => {
  const desktopHover = window.matchMedia(
    '(min-width: 750px) and (hover: hover) and (pointer: fine)'
  );

  const loadSecondaryImage = (event) => {
    if (!desktopHover.matches || !(event.target instanceof Element)) return;

    const wrapper = event.target.closest('.grid-image__wrapper');
    const imageLink =
      event.target.closest('.grid-image') || wrapper?.querySelector('.grid-image');
    if (!imageLink || imageLink.dataset.fdSecondaryLoaded === 'true') return;

    const template = imageLink.querySelector('.fd-secondary-image-template');
    if (!template) return;

    imageLink.appendChild(template.content.cloneNode(true));
    template.remove();
    imageLink.dataset.fdSecondaryLoaded = 'true';
  };

  document.addEventListener('pointerover', loadSecondaryImage, { passive: true });
  document.addEventListener('focusin', loadSecondaryImage);
})();
